import { json } from "@sveltejs/kit";
import { getFirestore } from "firebase-admin/firestore";
const POST = async ({ request }) => {
  try {
    const webhook = await request.json();
    await getFirestore().collection("bounce-log").add({
      email: webhook.Email,
      bounceType: webhook.Type === "HardBounce" ? "hard" : webhook.Type === "SoftBounce" ? "soft" : "spam_complaint",
      bouncedAt: new Date(webhook.BouncedAt).getTime(),
      reason: webhook.Description || "",
      messageId: webhook.MessageID
    });
    return json({ received: true });
  } catch (err) {
    console.error("Postmark webhook error:", err);
    return json({ received: false }, { status: 500 });
  }
};
export {
  POST
};
